import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import { Assignment } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { wsGet, wsFindBy, wsUpdate } from 'services/WService.js';

import ButtonDelete from 'hooks/ButtonDelete';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 150, align: 'center' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'RUC / DNI', accessor: 'LicTradNum', width: 150, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
export default function Mark() {
  const { id } = useParams();
  const classes = useStyles();

  const [notify, showNotify] = useToasty();
  const [mark, setMark] = useState({ bussiness_partners: [] });
  const [providers, setProviders] = useState([]);
  const [selectProvs, setSelecProvs] = useState([]);

  async function getMark() {
    let response = await wsGet('logi/mark', id);
    if (response.success) setMark(response.data);
  }

  async function listProvideers() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  const saveProviders = async () => {
    if (selectProvs.length === 0) {
      showNotify('Seleccione mínimo un proveedor', 'info');
      return;
    }
    const response = await wsUpdate('logi/mark', id, { base_business_partners: selectProvs });
    if (response.success) {
      showNotify(response.message);
      getMark();
      setSelecProvs([]);
    } else {
      showNotify(response.message, 'error');
    }
  };

  useEffect(() => {
    getMark();
    listProvideers();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardBody>
            <GridContainer
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <GridItem xs={12}>
                <h5>
                  <b>Marca:</b> ({mark.code}) {mark.description}
                </h5>
              </GridItem>
              <GridItem xs={9}>
                <Autocomplete
                  fullWidth
                  multiple
                  disableClearable
                  disableCloseOnSelect
                  options={providers}
                  getOptionLabel={(option) => option.CardName}
                  renderInput={(params) => (
                    <TextField {...params} label="Agregar proveedores" margin="normal" />
                  )}
                  onChange={(e, items) => {
                    let ids = items.map((item) => item.id);
                    setSelecProvs(ids);
                  }}
                />
              </GridItem>
              <GridItem xs={3}>
                <Button color="success" onClick={saveProviders}>
                  Guardar
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon pointer="true" color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de proveedores</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName={`Proveedores_marca_${mark.description}`}
              defaultWidth={1000}
              columns={columns}
              data={mark.bussiness_partners.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <ButtonDelete
                        entity={`base/business-partner/${item.id}/mark`}
                        id={mark.id}
                        reload={getMark}
                      />
                    </div>
                  ),
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  LicTradNum: item.LicTradNum,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
